import styled from 'styled-components';

export const MapContainer = styled.div`
  flex-grow: 1;
`;
